



















import { Vue, Component, Watch } from "vue-property-decorator";

import { Header as AppHeader } from "./components/organisms/Header";
import { Footer as AppFooter } from "./components/organisms/Footer";
import AuthPanel from "./components/organisms/AuthPanel.vue";

import { LoginModal } from "./components/organisms/Modal";
import {
  cartModule,
  contactsModule,
  indexModule,
  personalModule,
  pricesModule,
} from "./plugins/store-accessors";
import { getUser } from "./services/api/utils/getUser";
import { Storage } from "./services/interfaces/enums";
import ButtonsFloat from "@/components/common/ButtonsFloat.vue";

const marker = "B2B_FOCUS";

@Component({
  components: { ButtonsFloat, AppHeader, AppFooter, LoginModal, AuthPanel },
})
export default class App extends Vue {
  get isLoginModalShown() {
    return personalModule.isLoginModalShown;
  }

  get activeUser() {
    return personalModule.getUser || {};
  }

  get savedUser() {
    return personalModule.getSavedUser;
  }

  get isAutorized() {
    return personalModule.isAuthorized;
  }

  async logoutUser() {
    await personalModule.logoutAsUser();
    this.refreshRoute();
  }

  async refreshRoute() {
    await this.initialRequests();
    const { path, query } = this.$router.currentRoute;
    this.$router.replace({
      path,
      query: { ...query, refresh: Date.now().toString() },
    });
  }

  @Watch("$route")
  routeWatcher() {
    cartModule.ORDER_CLEAR();
  }

  checkAuthMode() {
    const SAVED_USER = getUser(Storage.SAVED_USER);

    if (this.savedUser && !SAVED_USER) {
      personalModule.setSavedUser(null);
      this.refreshRoute();
    }
    if (SAVED_USER && !this.savedUser) {
      personalModule.setSavedUser(SAVED_USER);
    }
  }

  checkWindowEvents() {
    if (!localStorage.getItem(marker)) {
      // to prevent HMR from adding multiple events
      window.addEventListener("focus", this.checkAuthMode);
      window.addEventListener("beforeunload", () => {
        localStorage.removeItem(marker);
      });
      localStorage.setItem(marker, "true");
    }
  }

  initialRequests() {
    cartModule.getCart();
    indexModule.requestData();
    contactsModule.requestData();
    personalModule.setActiveUser(getUser());
    pricesModule.requestPrices();
  }

  created() {
    const SAVED_USER = getUser(Storage.SAVED_USER);
    const USER = getUser();

    SAVED_USER && personalModule.setSavedUser(SAVED_USER);
    USER && personalModule.setActiveUser(USER);
  }

  mounted() {
    this.checkWindowEvents();
    this.initialRequests();
  }
}
